import styled from 'styled-components/macro';
import { Title2 } from 'components/text';
import { colors as Colors } from 'constants/colors';
import { media } from 'style/media';

export const ParallaxHeader = styled(Title2).attrs(props => ({
  centerTextSmall: true,
  large: true,
  min28onmobile: true
}))`
  font-size: 1.65rem;
  color: ${({ color }) => color || Colors.BLACK};
  margin-bottom: ${props => (props.large ? '0.8333rem' : '1rem')};
  ${media.desktop`
    color: ${Colors.BLACK};
    text-align: ${props => (props.centerTextSmall ? 'center' : 'left')};
  `};
`;

export const ParallaxHeaderMobile = styled(Title2).attrs(props => ({
  centerTextSmall: true,
  large: true,
  min28onmobile: true
}))`
  padding-bottom: 0.9rem;
  font-size: 1.45rem !important;
  color: ${({ color }) => color || Colors.BLACK};
  margin-bottom: 0;
`;